export const sink_url: string = "sink";